export enum PickerType {
    Date,
    Product,
}
